import * as logging from "./modules/logging";
import * as bisc from "./modules/bisc/api";
import * as fingerprinting from "./modules/fingerprinting";
import { biscReturnCode } from "./modules/return-codes";

if (process.env.NODE_ENV == 'production') {
    logging.disableLog();
}

let lib = {
    getLibraryVersion: () => "4.0.0",

    // Logging
    disableLog : logging.disableLog,
    enableLog : logging.enableLog,
    getLogLevel: logging.getLogLevel,
    logLevel : logging.logLevel,
    log : logging.log,

    // Error handling
    biscReturnCode : biscReturnCode,

    // Fingerprinting
    isBrowserMSInternetExplorer : fingerprinting.isBrowserMSInternetExplorer,
    isMacOS : fingerprinting.isMacOS,
    isPageHidden : fingerprinting.isPageHidden,
    callWhenPageVisible : fingerprinting.callWhenPageVisible,
    isWebExtensionsEnabled : fingerprinting.isWebExtensionsEnabled,

    // BISC
    isSecurityComponentsAvailable : bisc.isSecurityComponentsAvailable,
    getSecurityComponentsVersion  : bisc.getSecurityComponentsVersion,
    isCardReaderAvailable : bisc.isCardReaderAvailable,
    isIsabelCardReaderAvailable : bisc.isIsabelCardReaderAvailable,
    isIsabelCardAvailable : bisc.isIsabelCardAvailable,
    isIsabelCardCertificateValid : bisc.isIsabelCardCertificateValid,
    launchCardActivator : bisc.launchCardActivator,
    getIsabelCardId : bisc.getIsabelCardId,
    isIsabelCardPinChanged : bisc.isIsabelCardPinChanged,
    signEPaymentTokenWithIsabelCard : bisc.signEPaymentTokenWithIsabelCard,
    decryptPin : bisc.decryptPin,
    getExtensionVersion: bisc.getExtensionVersion,
    getApiVersion : bisc.getApiVersion,
    getCardReaders : bisc.getCardReaders,
    getBeidCardFiles : bisc.getBeidCardFiles,
    getBeidCardOwnerId : bisc.getBeidCardOwnerId,
    getBeidCardOwnerAddress : bisc.getBeidCardOwnerAddress,
    getBeidCardCertificates : bisc.getBeidCardCertificates,
    getBeidCardRootCACertificate : bisc.getBeidCardRootCACertificate,
    getBeidCardCitizenCACertificate : bisc.getBeidCardCitizenCACertificate,
    getBeidCardAuthenticationCertificate : bisc.getBeidCardAuthenticationCertificate,
    getBeidCardAuthenticationCertificateChain : bisc.getBeidCardAuthenticationCertificateChain,
    getBeidCardSignatureCertificate : bisc.getBeidCardSignatureCertificate,
    getBeidCardSignatureCertificateChain : bisc.getBeidCardSignatureCertificateChain,
    getBeidVersion : bisc.getBeidVersion,
    getIsabelCardVersion : bisc.getIsabelCardVersion,
    signAndPostEidPinChallengeWithBeidCard : bisc.signAndPostEidPinChallengeWithBeidCard,
    postBeidCardOwnerIdentity : bisc.postBeidCardOwnerIdentity,
    isBeidCardAvailable : bisc.isBeidCardAvailable,
    authenticateUserWithIsabelCard : bisc.authenticateUserWithIsabelCard,
    signChallengeWithBeidCard : bisc.signChallengeWithBeidCard,
    signAuthenticationChallengeWithBeidCard : bisc.signAuthenticationChallengeWithBeidCard,
    signAuthenticationChallengeWithIsabelCard : bisc.signAuthenticationChallengeWithIsabelCard,
    configuration : bisc.configuration
};

export const jBisc = lib;